import _classCallCheck from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { supportsScrollTimeline } from '../../utils/supports/scroll-timeline.mjs';
var BaseGroupPlaybackControls = /*#__PURE__*/function () {
  function BaseGroupPlaybackControls(animations) {
    var _this = this;
    _classCallCheck(this, BaseGroupPlaybackControls);
    // Bound to accomodate common `return animation.stop` pattern
    this.stop = function () {
      return _this.runAll("stop");
    };
    this.animations = animations.filter(Boolean);
  }
  _createClass(BaseGroupPlaybackControls, [{
    key: "finished",
    get: function get() {
      // Support for new finished Promise and legacy thennable API
      return Promise.all(this.animations.map(function (animation) {
        return "finished" in animation ? animation.finished : animation;
      }));
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */
  }, {
    key: "getAll",
    value: function getAll(propName) {
      return this.animations[0][propName];
    }
  }, {
    key: "setAll",
    value: function setAll(propName, newValue) {
      for (var i = 0; i < this.animations.length; i++) {
        this.animations[i][propName] = newValue;
      }
    }
  }, {
    key: "attachTimeline",
    value: function attachTimeline(timeline, fallback) {
      var _this2 = this;
      var subscriptions = this.animations.map(function (animation) {
        if (supportsScrollTimeline() && animation.attachTimeline) {
          return animation.attachTimeline(timeline);
        } else if (typeof fallback === "function") {
          return fallback(animation);
        }
      });
      return function () {
        subscriptions.forEach(function (cancel, i) {
          cancel && cancel();
          _this2.animations[i].stop();
        });
      };
    }
  }, {
    key: "time",
    get: function get() {
      return this.getAll("time");
    },
    set: function set(time) {
      this.setAll("time", time);
    }
  }, {
    key: "speed",
    get: function get() {
      return this.getAll("speed");
    },
    set: function set(speed) {
      this.setAll("speed", speed);
    }
  }, {
    key: "startTime",
    get: function get() {
      return this.getAll("startTime");
    }
  }, {
    key: "duration",
    get: function get() {
      var max = 0;
      for (var i = 0; i < this.animations.length; i++) {
        max = Math.max(max, this.animations[i].duration);
      }
      return max;
    }
  }, {
    key: "runAll",
    value: function runAll(methodName) {
      this.animations.forEach(function (controls) {
        return controls[methodName]();
      });
    }
  }, {
    key: "flatten",
    value: function flatten() {
      this.runAll("flatten");
    }
  }, {
    key: "play",
    value: function play() {
      this.runAll("play");
    }
  }, {
    key: "pause",
    value: function pause() {
      this.runAll("pause");
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.runAll("cancel");
    }
  }, {
    key: "complete",
    value: function complete() {
      this.runAll("complete");
    }
  }]);
  return BaseGroupPlaybackControls;
}();
export { BaseGroupPlaybackControls };